import { ComponentsOverrides, ComponentsProps, ComponentsVariants, Theme } from '@mui/material/styles';

export const classes: {
    defaultProps?: ComponentsProps['MuiInput'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiInput'];
    variants?: ComponentsVariants['MuiInput'];
} = {
    styleOverrides: {
        root: {
            borderRadius: '4px',
            backgroundColor: '#ffffff',

            '&$error': {
                borderColor: '#E2004F',
            },
            // NOTE: https://stackoverflow.com/a/57915357
            '&&&:before': {
                borderBottom: 'none',
            },
            '&&:after': {
                borderBottom: 'none',
            },
            '&.Mui-focused': {
                '& fieldset': {
                    borderColor: '#2196F3',
                },
            },
        },
        input: {
            height: 22,
            fontSize: 15,
            lineHeight: '21px',
            borderRadius: '4px',
            backgroundColor: '#ffffff',
            padding: '17px 14px',
        },
        multiline: {
            '& textarea': {
                padding: 0,
            },
        },
        inputMultiline: {
            '&::-webkit-scrollbar': {
                width: 5,
            },
            '&::-webkit-scrollbar-thumb': {
                background: '#2C93F0',
                borderRadius: 2.5,
            },
            '&::-webkit-scrollbar-track': {
                background: '#D5DFEB',
                borderRadius: 2.5,
            },
        },
    },
};
